module.exports = __webpack_public_path__ + "static/media/55_000037.1b2a7cfe.jpg";